export default class KeyContactVO
{
    name: string = "";
    role: string = "";
    emailAddress: string = "";
    telephoneNumber: string = "";
}